<div class="container">
    <div class="row justify-content-center">
        <div class="col-12" [ngClass]="{ 'col-lg-6': !isEditMode }">
            <div class="card">
                <div class="card-header bg-secondary">Order details</div>
                <div class="card-body order-details" *ngIf="orderDetails | async">
                    <div class="d-flex flex-row">
                        {{ 'my-tasks.bag' | translate }}:&nbsp;
                        <div *ngIf="(orderDetails | async).usePaperBag; else multiUseBag">
                            {{ 'my-tasks.paper-bag' | translate }}
                        </div>
                        <ng-template #multiUseBag>
                            <td *ngIf="(orderDetails | async).usePaperBag === false">
                                {{ 'my-tasks.multiuse-bag' | translate }}
                            </td>
                        </ng-template>
                    </div>

                    <div class="d-flex flex-row align-items-center">
                        {{ 'common.payment-type' | translate }}:&nbsp;

                        <ng-container *ngIf="orderDetails | async as details">

                            <div *ngIf="!isPaymentTypeEditing" class="d-flex align-items-center mx-1">
                                {{ getPaymentTypeKey(details.paymentType) | translate }}
                                <button *ngIf="isPaymentTypeEditVisible" class="btn btn-sm btn-warning payment-type-edit-btn" (click)="isPaymentTypeEditing = true">
                                    {{ 'common.edit' | translate }}
                                </button>
                            </div>

                        <div *ngIf="isPaymentTypeEditing" class="d-flex align-items-center">

                            <select [(ngModel)]="selectedPaymentType" class="form-select mx-1">
                                <option [ngValue]="PaymentType.PayOnDeliveryCard">
                                    {{ getPaymentTypeKey(PaymentType.PayOnDeliveryCard) | translate }}
                                </option>
                                <option [ngValue]="PaymentType.PayOnDeliveryCash">
                                    {{ getPaymentTypeKey(PaymentType.PayOnDeliveryCash) | translate }}
                                </option>
                            </select>

                            <button class="btn btn-sm btn-primary payment-type-edit-btn" (click)="savePaymentMode(details)" [disabled]="selectedPaymentType == details.paymentType || isSaving">
                                {{ 'common.save' | translate }}
                            </button>

                            <button class="btn btn-sm btn-secondary payment-type-edit-btn" (click)="cancelPaymentModeEdit(details)">
                                {{ 'common.cancel' | translate }}
                            </button>
                        </div>

                        </ng-container>

                    </div>

                    <div class="d-flex flex-row">
                        {{ 'collecting.consultation-type' | translate }}:&nbsp;
                        <div>
                            {{ (orderDetails | async).consultationType | translate }}
                        </div>
                    </div>
                    <br />
                    <app-task-details-item
                        *ngFor="let taskInfo of (orderDetails | async).deliveryTasks"
                        [taskInfo]="taskInfo"
                    >
                    </app-task-details-item>
                    <app-customer-notes
                        [notes]="(orderDetails | async).orderNotes"
                    ></app-customer-notes>
                    <div class="w-100 my-1">
                        <app-support-comment
                            [notes]="(orderDetails | async).supportComment"
                        ></app-support-comment>
                    </div>
                    <div *ngIf="(orderDetails | async).isSuperOrder" class="w-100 my-1">
                        <app-multi-order-info
                            [superOrderCode]="(orderDetails | async).superOrderCode"
                            [orderCodeList]="(orderDetails | async).orderCodeList"
                        ></app-multi-order-info>
                    </div>
                </div>
                <div class="card-footer" *ngIf="areDeliveryTaskButtonsVisible">
                    <div class="row text-center">
                        <lib-btn-progress
                            class="col-lg-6 mt-1 mb-1"
                            [inProgress]="collectingTaskCreationInProgress"
                            *ngIf="!hasCollectingTask"
                            (onClick)="createCollectingTask()"
                            [btnClass]="'btn btn-block btn-sm btn-info'"
                            >{{
                                'orders.create-collecting-task' | translate
                            }}</lib-btn-progress
                        >
                        <br />
                        <lib-btn-progress
                            class="col-lg-6 mt-1 mb-1"
                            [inProgress]="containerPlacingTaskCreationInProgress"
                            *ngIf="!hasContainerPlacingTask"
                            (onClick)="createContainerPlacingTask()"
                            [btnClass]="'btn btn-block btn-sm btn-info'"
                            >{{
                                'orders.create-container-placing-task' | translate
                            }}</lib-btn-progress
                        >
                        <br />
                        <lib-btn-progress
                            class="col-lg-6 mt-1 mb-1"
                            [inProgress]="deliveringTaskCreationInProgress"
                            *ngIf="!hasDeliveringTask"
                            (onClick)="createDeliveringTask()"
                            [btnClass]="'btn btn-block btn-sm btn-warning'"
                            >{{
                                'orders.create-delivering-task' | translate
                            }}</lib-btn-progress
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
